import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const initGSAPSpiralGallery = () => {

	const root = document.querySelector('.our-work-collage');

	if (!root) return;

	const container = root.querySelector('.wrap');
	const mediaWrappers = root.querySelectorAll('.media-wrapper')
	const mediasLength = mediaWrappers.length;
	const angle = 360 / mediasLength
	const medias = root.querySelectorAll('.media')

	mediaWrappers.forEach((wrapper, index) => {
		gsap.set(wrapper, { rotation: -angle * index })
		gsap.set(medias[index], { rotation: angle * index })
	})

	const tl = gsap.timeline({
		scrollTrigger: {
			trigger: '.our-work-collage',
			start: 'top top',
			end: 'bottom bottom',
			pin: container,
			scrub: 1
		}
	});

	tl.to(mediaWrappers, {
		rotation: '+=180',
		stagger: 0.04,
		ease: 'power1.out',
	})
	tl.to(medias, {
		x: 0,
		rotation: '-=180',
		ease: 'power1.out',
		stagger: 0.04,
	}, '<');
	tl.from(medias, {
		autoAlpha: 0,
		duration: 0.03,
		stagger: 0.04,
	}, '<')

}

export { initGSAPSpiralGallery };